import { makeStyles } from 'tss-react/mui';

const useBrandSelectModalStyles = makeStyles()(() => ({
  goToStoreIcon: {
    paddingLeft: '4px',
    width: 28,
    height: 28,
  },
  goToStoreButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '12px',
    height: '48px',
    marginTop: '8px',
    marginBottom: '-16px',
    borderRadius: '20px',
  },
}));

export default useBrandSelectModalStyles;
